import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

const ProCompanies = () => (
  <>
    <div className='flex lg:hidden px-2'>
      <div className='flex justify-center items-center gap-6 md:gap-10 flex-wrap'>
        <StaticImage
          loading='lazy'
          src='../../img/pro/common.webp'
          className='w-[230px] h-[99px] object-cover' alt='common threadロゴ' />
        <StaticImage
          loading='lazy'
          src='../../img/pro/murakami.webp'
          className='w-[234px] h-[87px] object-none' alt='村上医院ロゴ' />
        <StaticImage
          loading='lazy'
          src='../../img/pro/isyo.webp'
          className='w-[85px] h-[84px] object-none' alt='意匠計画ロゴ' />
        <StaticImage
          loading='lazy'
          src='../../img/pro/jr.webp' className='w-[221px] h-[87px] object-cover' alt='JRロゴ✖️handyロゴ' />
        <StaticImage
          loading='lazy'
          src='../../img/pro/bfo.webp'
          className='w-[216px] h-[71px] rounded-[50px] object-cover' alt='BFOロゴ' />
      </div>
    </div>
    <div className='hidden lg:flex flex-col justify-start items-center relative overflow-hidden'>
      <div className='flex justify-start items-center flex-grow-0 flex-shrink-0 relative gap-2 xl:gap-12'>
        <StaticImage
          loading='lazy'
          src='../../img/pro/common.webp'
          className='flex-grow-0 flex-shrink-0 w-[230px] h-[99px] object-cover' alt='common threadロゴ' />
        <StaticImage
          loading='lazy'
          src='../../img/pro/murakami.webp'
          className='flex-grow-0 flex-shrink-0 w-[234px] h-[87px] object-none' alt='村上医院ロゴ' />
        <StaticImage
          loading='lazy'
          src='../../img/pro/isyo.webp'
          className='flex-grow-0 flex-shrink-0 w-[85px] h-[84px] object-none' alt='意匠計画ロゴ' />
        <StaticImage
          loading='lazy'
          src='../../img/pro/jr.webp' className='flex-grow-0 flex-shrink-0 w-[221px] h-[87px] object-cover' alt='JRロゴ✖️handyロゴ' />
        <StaticImage
          loading='lazy'
          src='../../img/pro/bfo.webp'
          className='flex-grow-0 flex-shrink-0 w-[216px] h-[71px] rounded-[50px] object-cover' alt='BFOロゴ' />
      </div>
    </div>
  </>
)

export default ProCompanies